import React, { MouseEventHandler, useCallback } from 'react';
import classNames from 'classnames';
import { Tooltip } from '../tooltip/Tooltip';
import { Icon } from '../icon/Icon';
import styled from 'styled-components';

type Props = {
	className?: string;
	label: string;
	onClick?: (eventParameter?: string) => void;
	url?: string;
	title?: string;
	icon?: string;
	rightIcon?: string;
	eventParameter?: string;
	disabled?: boolean;
};

const StyledLink = styled.a`
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;

	&[disabled] {
		cursor: not-allowed;
	}
`;

const Content = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 8px;
	min-width: 0;
`;

const RightIconWrapper = styled.span`
	display: inline-flex;
	align-items: center;
	flex-shrink: 0;
`;

export const DropdownMenuAction = ({
	className,
	title,
	label,
	onClick,
	url,
	icon,
	rightIcon,
	eventParameter,
	disabled,
	...otherProps
}: Props) => {
	const onClickCallback = useCallback(
		(e: Parameters<MouseEventHandler<HTMLAnchorElement>>[0]) => {
			if (disabled) {
				e.preventDefault();
			} else if (!url) {
				e.preventDefault();
				onClick?.(eventParameter);
			}
		},
		[url, eventParameter, onClick, disabled]
	);

	const menuAction = (
		<li className={classNames(className, { disabled })}>
			<StyledLink
				onClick={onClickCallback}
				{...(url && { href: url })}
				{...otherProps}
			>
				<Content>
					{icon ? <Icon name={icon} /> : null}
					<span>{label}</span>
				</Content>

				{rightIcon ? (
					<RightIconWrapper>
						<Icon name={rightIcon} />
					</RightIconWrapper>
				) : null}
			</StyledLink>
		</li>
	);

	return title ? <Tooltip message={title} placement="bottom">{menuAction}</Tooltip> : menuAction;
};

export function DropdownMenuSeparator() {
	return <li role="separator" className="divider"></li>;
}
